<template>
  <div class="customerList">
    <FORM ref="childForm" @formclick="formclick" :formData="formData"></FORM>
    <UPDATE ref="childUpdate" @submit="submit" :updateData="updateData" @uploadFile="uploadFile"></UPDATE>
    <table-page ref="childTable" @btnclick="bthClick" :pageData="pageData"></table-page>
  </div>
</template>

<script>
import Url from '@/views/proxy_cfint/util/url'
import DateUtil from '@/utils/IM/tradeDataUtil'
import FORM from '@/components/page/form'
import tablePage from '@/components/page/table'
import download from '@/utils/download'
import UPDATE from '@/components/page/update'
import Qs from 'qs'

export default {
  name: 'customerExclude',
  components: {
    FORM,
    tablePage,
    UPDATE
  },

  data() {
    return {
      queryData: {},
      updateData: {
        cols: [
          {
            title: '用戶列表',
            field: 'customerNumbers',
            type: 11,
            action: Url.utils.uploadFile,
            downUrl: 'https://static.chwenda.com/source/downloadModel/用户模板.xlsx',
            required: true
          },
        ]
      },
      /*from查询表单*/
      formData: {
        hasLable: true,
        cols: [
          { click: window.$t('common.add'), auth: 'proxy_cfint:excludeCustomer:add' }
        ]
      },
      /*table生成*/
      pageData: {
        queryUrl: Url.adAgent.excludeCustomers,
        selection: false,
        sequence: false,
        method: 'get',
        cols: [
          { title: '交易账号', field: 'customerNumber' },
          { title: '添加人', field: 'cname' },
          {
            title: '添加時間', field: 'ctime', render: (data, full) => {
              return DateUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
            }
          },
          {
            title: window.$t('common.operation'),
            btnClick: [
              {
                name: window.$t('common.delete'),
                click: 'delete',
                type: 'primary',
                icon: 'el-icon-delete',
                auth: 'proxy_cfint:excludeCustomer:del'
              }
            ]
          }
        ]
      },
      totalNum: {}
    }
  },
  methods: {
    dataChange(url, option, suc, fail) {
      this.$axios.post(url, Qs.stringify(option || {})).then(res => {
        if (suc && (typeof suc == 'function')) suc(res)
      }).catch(res => {
        if (fail && (typeof fail == 'function')) fail(res)
      })
    },
    uploadFile(col, result) {
      console.info(result)
      //col.data = (result || []).join(',')
      this.$set(col,"data",(result || []).join(','));
      console.info(col)
    },
    submit(model) {
      this.dataChange(Url.adAgent.saveExcludeCustomers, model, res => {
        if (res.code == 0) {
          this.$refs.childUpdate.close()
          this.$message.success('操作成功')
          this.$refs.childTable.defaultQueryData(this.queryData)
        } else {
          this.$message.error(res.message)
        }
      })
    },
    bthClick(clickName, row) {
      if (clickName == 'delete') {
        let option = {
          customerNumber: row.customerNumber
        }
        this.dataChange(Url.adAgent.delExcludeCustomers, option, res => {
          if (res.code == 0) {
            this.$refs.childTable.defaultQueryData(this.queryData)
            this.$message.success('suc')
          } else {
            this.$message.error(res.message)
          }
        })
      }
    },

    /*查询表单按钮点击事件*/
    formclick(clickName, data) {
      if (window.$t('common.search') == clickName || '查询' == clickName) {
        data.startTime = data.startTime ? new Date(data.startTime).getTime() : ''
        data.endTime = data.endTime ? new Date(data.endTime).getTime() : ''
        this.queryData = data
        this.$refs.childTable.defaultQueryData(data)
      }else if (window.$t('common.add') == clickName || '增加' == clickName) {
        this.$refs.childUpdate.open()
      }
    }
  },
  mounted() {
  }
}
</script>

<style>
.customerList .total_con {
  width: 96%;
  margin: 0 auto;
}

.customerList .total_con .el-form-item {
  margin: 0 30px 0 0;
}

.customerList .total_con p {
  color: #ff5500;
  font-size: 16px;
  font-weight: bolder;
}
</style>
